import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
    constructor(private localization: LocalizationService) { }

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        const currentLanguage = this.getCurrentLanguage();

        // Clone the request and add the Accept-Language header
        const clonedRequest = request.clone({
            headers: request.headers.set('Accept-Language', currentLanguage)
        });

        return next.handle(clonedRequest);
    }

    private getCurrentLanguage(): string {
        return this.localization.getCachedLanguage() ?? 'en';
    }
} 